"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const DistroSliderItem_vue_1 = __importDefault(require("./DistroSliderItem.vue"));
const DistroLoaderInline_vue_1 = __importDefault(require("../components/DistroLoaderInline.vue"));
const ViewZeroDistro_vue_1 = __importDefault(require("./ViewZeroDistro.vue"));
const floating_vue_1 = require("floating-vue");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
let DistroSlider = class DistroSlider extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.colorManager = new ColorLibController_1.default();
        this.currentItemId = this.currentSliderItemId;
        this.sliderItemsInitials = [];
    }
    categoryTransform(category) {
        return this.colorManager.getAlphaCategory(category);
    }
    reloadActive() {
        let exist = false;
        for (const item of this.items) {
            if (item.id === this.currentItemId) {
                exist = true;
            }
            else {
                this.emitNewSliderItemActive(this.items[0].id, this.items[0].area.areaID);
                exist = false;
            }
        }
        return exist;
    }
    reloadSliderItems() {
        if (!this.isLoading)
            this.sliderItemsInitials = this.sliderItems.sliderItems;
    }
    isCurrentSliderItem(item) {
        if (item === this.sliderItems.currentItem)
            return true;
        return false;
    }
    emitNewSliderItemActive(newCurrentId, newAreaId) {
        if (this.currentItemId !== newCurrentId) {
            this.$emit('newCurrentId', newCurrentId, newAreaId);
            this.currentItemId = newCurrentId;
        }
    }
    get hasLoader() {
        if (this.isLoading && this.sliderItemsInitials.length < 1)
            return true;
        return false;
    }
    get hasViewZero() {
        if (!this.isLoading && this.sliderItems.sliderItems.length < 1)
            return true;
        return false;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: [] })
], DistroSlider.prototype, "sliderItems", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], DistroSlider.prototype, "currentSliderItemId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], DistroSlider.prototype, "isLoading", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], DistroSlider.prototype, "items", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('items')
], DistroSlider.prototype, "reloadActive", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('isLoading')
], DistroSlider.prototype, "reloadSliderItems", null);
DistroSlider = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            DistroSliderItem: DistroSliderItem_vue_1.default,
            Dropdown: floating_vue_1.Dropdown,
            WarningRoundedIcon: bmk_ui_framework_1.WarningRoundedIcon,
            DistroLoaderInline: DistroLoaderInline_vue_1.default,
            ViewZeroDistro: ViewZeroDistro_vue_1.default,
            FilterIcon: bmk_ui_framework_1.FilterIcon,
        },
    })
], DistroSlider);
exports.default = DistroSlider;
